module.exports = __webpack_public_path__ + "img/腳色介面_03-完成.d47965a2.png";